import { bluePaletteDark, grayPaletteDark, redPaletteDark, royalBluePaletteDark } from '../../themes/dark-colors';
import { IInputTheme } from './theme';

export const inputDarkTheme: IInputTheme = {
  variants: {
    primary: {
      styles: {
        color: royalBluePaletteDark[1000],
        background: grayPaletteDark[100],
        borderColor: grayPaletteDark[300],
      },
      placeholder: {
        color: grayPaletteDark[700],
      },
      active: {
        color: royalBluePaletteDark[1000],
        borderColor: royalBluePaletteDark[1000],
        shadowColor: bluePaletteDark[300],
        '&::placeholder': {
          color: grayPaletteDark[700],
        },
      },
      hover: {
        color: royalBluePaletteDark[1000],
        borderColor: bluePaletteDark[700],
      },
      focus: {
        color: royalBluePaletteDark[1000],
        borderColor: royalBluePaletteDark[1000],
        '&::placeholder': {
          color: grayPaletteDark[700],
        },
      },
      disabled: {
        color: grayPaletteDark[700],
        background: grayPaletteDark[300],
        borderColor: grayPaletteDark[300],
        '&::placeholder': {
          color: grayPaletteDark[500],
        },
      },
      borderless: {
        borderColor: grayPaletteDark[300],
        hover: {
          borderColor: royalBluePaletteDark[1000],
        },
      },
      error: {
        borderColor: redPaletteDark[600],
        hover: {
          borderColor: redPaletteDark[700],
        },
        active: {
          shadowColor: redPaletteDark[200],
        },
      },
    },
    secondary: {
      styles: {
        color: grayPaletteDark[100],
        background: grayPaletteDark[100],
        borderColor: grayPaletteDark[300],
      },
      placeholder: {
        color: grayPaletteDark[700],
      },
      active: {
        color: grayPaletteDark[100],
        borderColor: grayPaletteDark[100],
        shadowColor: bluePaletteDark[300],
        '&::placeholder': {
          color: grayPaletteDark[700],
        },
      },
      hover: {
        color: grayPaletteDark[100],
        borderColor: grayPaletteDark[100],
      },
      focus: {
        color: grayPaletteDark[100],
        borderColor: grayPaletteDark[100],
        '&::placeholder': {
          color: grayPaletteDark[700],
        },
      },
      disabled: {
        color: grayPaletteDark[700],
        background: grayPaletteDark[300],
        borderColor: grayPaletteDark[300],
        '&::placeholder': {
          color: grayPaletteDark[500],
        },
      },
      borderless: {
        borderColor: grayPaletteDark[300],
        hover: {
          borderColor: grayPaletteDark[100],
        },
      },
      error: {
        borderColor: redPaletteDark[600],
        hover: {
          borderColor: redPaletteDark[700],
        },
        active: {
          shadowColor: redPaletteDark[200],
        },
      },
    },
  },
};
